import { useEffect, useRef, useState } from "react";
import IotDetails from "../../components/ThirdPartyDashboard/IotDetails";
import SideBar from "../../components/ThirdPartyDashboard/SideBar";
import "../../styles/ThirdParty/Iot.scss";
import {
  getDatabase,
  ref,
  onValue,
  orderByChild,
  equalTo,
  query,
} from "firebase/database";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from "react-router-dom";
import Search from "../../components/ThirdPartyDashboard/Search";
import { useSelector } from "react-redux";
import { Tooltip, Typography } from "@mui/material";
import isTimestampWithinHourAndTenMinutes from "../../utils/iotUptime";

const Iot = () => {
  const auth = useSelector((state) => state.auth);
  const [modalOpen, setModalOpen] = useState(false)
  const [devices, setDevices] = useState([])
  const [selectedDevice, setSelectedDevices] = useState([])
  const [loading, setLoading] = useState(false)
  const handlModalClose = () => setModalOpen(false)
  const [deviceUptimes, setDeviceUptimes] = useState({});
  const [deviceBatteryLevel, setDeviceBatteryLevel] = useState(0);

  const handleModalOpen = (device) => {
    setSelectedDevices(device)
    setModalOpen(true)
  }
  const navigate = useNavigate()

  const db = getDatabase();
  const tableRef = ref(db, "prod-sensors-table");
  // const tableRef = ref(db, "dev-sensors-table");
  const FirebASE = process.env.REACT_APP_FIREBASE
  const tableRef2 = ref(db, FirebASE);
  const listenersRef = useRef([]);


  useEffect(() => {
    setLoading(true);


    const unsubscribe = onValue(tableRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = Object.values(snapshot.val());
        console.log("devices found", data);
        setDevices(data?.reverse());

        // Set up listeners for each device
        data.forEach((device) => {
          const deviceQuery = query(
            tableRef2,
            orderByChild("deviceId"),
            equalTo(device.id)
          );
          const listener = onValue(deviceQuery, (snapshot) => {
            if (snapshot.exists()) {
              const data = Object.values(snapshot.val());
              const mostRecentObject = data.reduce((latest, current) => {
                return parseInt(current.createdAt) > parseInt(latest.createdAt) ? current : latest;
              });

              const isUptime = isTimestampWithinHourAndTenMinutes(mostRecentObject?.createdAt);

              setDeviceUptimes(prev => ({
                ...prev,
                [device.id]: isUptime
              }));
              setDeviceBatteryLevel((prev) => ({
                ...prev,
                [device.id]: mostRecentObject?.batteryLevel,
              }));
            }
          });
          listenersRef.current.push(listener);
        });
      } else {
        console.log(`No data found`);
      }
      setLoading(false);
    });

    // Cleanup function
    return () => {
      unsubscribe();
      listenersRef.current.forEach((listener) => {
        listener(); // Remove the listener
      });
      listenersRef.current = [];
    };
  }, [auth?.userInfo?.id]);


  return (
    <div className="iot">
      <div className="sidebar_container">
        <SideBar />
      </div>

      <div className="main">
        <Search />
        <div className="title">IoT Devices</div>

        {loading && <div className="grid">
          <div className="card">
            <div className="grid_inner">
              {/* <div className="subtitle bold">Name of Organisation:</div> */}
              {/* <div>CloseCarbon</div> */}
              <div className="subtitle bold"><Skeleton
                width={100}
                height={30}
                borderRadius={4}
              /></div>
              <div><Skeleton
                // width={100}
                height={30}
                borderRadius={4}
              /></div>

            </div>

            <div className="flex">
              <div className="flex_inner">

                <div><Skeleton
                  width={100}
                  height={30}
                  borderRadius={4}
                /></div>
              </div>
              <div className="flex_inner">


                <div><Skeleton
                  width={240}
                  height={30}
                  borderRadius={4}
                /></div>
              </div>
            </div>

            <div className="more pointer bold"><Skeleton
              width={100}
              height={30}
              borderRadius={4}
            /></div>
          </div>
          <div className="card">
            <div className="grid_inner">
              {/* <div className="subtitle bold">Name of Organisation:</div> */}
              {/* <div>CloseCarbon</div> */}
              <div className="subtitle bold"><Skeleton
                width={100}
                height={30}
                borderRadius={4}
              /></div>
              <div><Skeleton
                // width={100}
                height={30}
                borderRadius={4}
              /></div>

            </div>

            <div className="flex">
              <div className="flex_inner">

                <div><Skeleton
                  width={100}
                  height={30}
                  borderRadius={4}
                /></div>
              </div>
              <div className="flex_inner">


                <div><Skeleton
                  width={240}
                  height={30}
                  borderRadius={4}
                /></div>
              </div>
            </div>

            <div className="more pointer bold"><Skeleton
              width={100}
              height={30}
              borderRadius={4}
            /></div>
          </div>
          <div className="card">
            <div className="grid_inner">
              {/* <div className="subtitle bold">Name of Organisation:</div> */}
              {/* <div>CloseCarbon</div> */}
              <div className="subtitle bold"><Skeleton
                width={100}
                height={30}
                borderRadius={4}
              /></div>
              <div><Skeleton
                // width={100}
                height={30}
                borderRadius={4}
              /></div>

            </div>

            <div className="flex">
              <div className="flex_inner">

                <div><Skeleton
                  width={100}
                  height={30}
                  borderRadius={4}
                /></div>
              </div>
              <div className="flex_inner">


                <div><Skeleton
                  width={240}
                  height={30}
                  borderRadius={4}
                /></div>
              </div>
            </div>

            <div className="more pointer bold"><Skeleton
              width={100}
              height={30}
              borderRadius={4}
            /></div>
          </div>
          <div className="card">
            <div className="grid_inner">
              {/* <div className="subtitle bold">Name of Organisation:</div> */}
              {/* <div>CloseCarbon</div> */}
              <div className="subtitle bold"><Skeleton
                width={100}
                height={30}
                borderRadius={4}
              /></div>
              <div><Skeleton
                // width={100}
                height={30}
                borderRadius={4}
              /></div>

            </div>

            <div className="flex">
              <div className="flex_inner">

                <div><Skeleton
                  width={100}
                  height={30}
                  borderRadius={4}
                /></div>
              </div>
              <div className="flex_inner">


                <div><Skeleton
                  width={240}
                  height={30}
                  borderRadius={4}
                /></div>
              </div>
            </div>

            <div className="more pointer bold"><Skeleton
              width={100}
              height={30}
              borderRadius={4}
            /></div>
          </div>


        </div>}
     
     
        {modalOpen && <IotDetails handlModalClose={handlModalClose} device={selectedDevice} />}
      </div>

    </div>
  );
};

export default Iot;
